import { createSelector } from "reselect";

import { createDataSelectors } from "@app/modules/app.reducers";
import { Step } from "@ea/shared_types/types";
import { CoreCommandsIds } from "@ea/shared_types/core.commands.types";

export const stepsDataSelectors = createDataSelectors<Step>()("steps");

export const getStepsSelector = createSelector(stepsDataSelectors.getOrderedDataSelector, (steps) =>
  steps.map((step, index) =>
    index === 0 || index === steps.length - 1 ? { ...step, isDragDisabled: true } : step,
  ),
);
export const getSelectedStepSelector = stepsDataSelectors.getSelectedItemSelector;
export const getSelectedStepsMapSelector = createSelector(
  stepsDataSelectors.getSelectedSelector,
  (selected) =>
    selected.reduce((map: any, obj: any) => {
      map[obj] = obj;
      return map;
    }, {}),
);
export const getSelectedStepsSelector = stepsDataSelectors.getSelectedItemsSelector;
export const getSelectedSelector = stepsDataSelectors.getSelectedSelector;
export const getStepsOrderSelector = stepsDataSelectors.getOrderSelector;
export const getScriptStepsSelector = createSelector(
  stepsDataSelectors.getOrderedDataSelector,
  (steps) => steps.filter((s) => s.commandId === CoreCommandsIds.script),
);
export const getNotSelectableStepsSelector = createSelector(
  stepsDataSelectors.getOrderedDataSelector,
  (steps) =>
    steps
      .filter(
        (step) =>
          step.commandId === CoreCommandsIds.start || step.commandId === CoreCommandsIds.end,
      )
      .map((step) => step.id),
);
